import Client from './Client';

export default class ConfigClient {
  constructor() {
    this.client = Client;
  }

  /**
   * 获取购课须知
   */
  async getCoursePurchaseNotice() {
    const res = await this.client.post('/api/sys/config/getCoursePurchaseNotice');
    return res;
  }

  /**
   * 编辑购课须知
   */
  async updateCoursePurchaseNotice(data) {
    const res = await this.client.post('/api/sys/config/updateCoursePurchaseNotice', data);
    return res;
  }

  /**
   * 获取考试须知
   */
  async getExamPurchaseNotice() {
    const res = await this.client.post('/api/sys/config/getExamPurchaseNotice');
    return res;
  }

  /**
   * 编辑考试须知
   */
  async updateExamPurchaseNotice(data) {
    const res = await this.client.post('/api/sys/config/updateExamPurchaseNotice', data);
    return res;
  }

  /**
   * 获取理论考试须知
   */
  async getQuestionExamPurchaseNotice() {
    const res = await this.client.post('/api/sys/config/getQuestionExamPurchaseNotice');
    return res;
  }

  /**
   * 编辑理论考试须知
   */
  async updateQuestionExamPurchaseNotice(data) {
    const res = await this.client.post('/api/sys/config/updateQuestionExamPurchaseNotice', data);
    return res;
  }

  /**
   * 获取视频考试须知
   */
  async getVideoExamPurchaseNotice() {
    const res = await this.client.post('/api/sys/config/getVideoExamPurchaseNotice');
    return res;
  }

  /**
   * 编辑考试须知
   */
  async updateVideoExamPurchaseNotice(data) {
    const res = await this.client.post('/api/sys/config/updateVideoExamPurchaseNotice', data);
    return res;
  }

  /**
   * 获取热搜
   */
  async listHotSearch() {
    const res = await this.client.post('/api/sys/config/listHotSearch');
    return res;
  }

  /**
   * 编辑热搜
   */
  async updateHotSearch(data) {
    const res = await this.client.post('/api/sys/config/updateHotSearch', data);
    return res;
  }

  /**
   * 咨询电话查询
   */
  async listSupportMobilePhone() {
    const res = await this.client.post('/api/sys/config/listSupportMobilePhone');
    return res;
  }

  /**
   * 咨询电话编辑
   */
  async updateSupportMobilePhone(data) {
    const res = await this.client.post('/api/sys/config/updateSupportMobilePhone', data);
    return res;
  }

  /**
   * 失败原因查询
   */
  async listAuditFailReason() {
    const res = await this.client.post('/api/sys/config/listAuditFailReason');
    return res;
  }

  /**
   * 失败原因编辑
   */
  async updateAuditFailReason(data) {
    const res = await this.client.post('/api/sys/config/updateAuditFailReason', data);
    return res;
  }

  /**
   * 新增修改理论考试费用
   */
  async upsertQuestionExamFee(data) {
    const res = await this.client.post('/api/sys/config/upsertQuestionExamFee', data);
    return res;
  }

  /**
   * 查询理论考试费用
   */
  async getQuestionExamFee(data) {
    const res = await this.client.post('/api/sys/config/getQuestionExamFee', data);
    return res;
  }

  /**
   * 新增修改视频考试费用
   *
   */
  async upsertVideoExamFee(data) {
    const res = await this.client.post('/api/sys/config/upsertVideoExamFee', data);
    return res;
  }

  /**
   * 查询视频考试费用
   *
   */
  async getVideoExamFee(data) {
    const res = await this.client.post('/api/sys/config/getVideoExamFee', data);
    return res;
  }

  /**
   * 查询视频考试费用
   *
   */
  async getEvaluationIconTagNotice(data) {
    const res = await this.client.post('/api/sys/config/getEvaluationIconTagNotice', data);
    return res;
  }

  /**
   * 查询视频考试费用
   *
   */
  async updateEvaluationIconTagNotice(data) {
    const res = await this.client.post('/api/sys/config/updateEvaluationIconTagNotice', data);
    return res;
  }
}